import React from "react";
import { MainLayout } from "src/apps/commons/layouts";
import { UploadSSW } from "src/apps/modules/uploadData";

const Page = () => <UploadSSW />;
Page.Layout = MainLayout;
export default Page;
